<div class="form-input" [formGroup]="group" class="{{config.size.toString()}}" *ngIf="isVisible">
    <wtf-errors-indicator [errors]="errors"></wtf-errors-indicator>
    <mat-form-field *ngIf="!inline">
        <mat-select #select placeholder="{{config.fieldInfo.caption}}" id="{{config.fieldInfo.name}}" [formControlName]="config.fieldInfo.name" ng-model-options="{trackBy: '$value.id'}" (focus)="onFocus($event)" (blur)="onLostFocus($event)">
            <mat-option *ngFor="let option of options | async" [value]="option[idPropertyName]">
                {{option[valuePropertyName]}}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <label for="config.fieldInfo.name" class="label" *ngIf="inline">{{config.fieldInfo.caption}}</label>
    <mat-select #select class="inline-field" *ngIf="inline" placeholder="{{config.fieldInfo.caption}}" id="{{config.fieldInfo.name}}" [formControlName]="config.fieldInfo.name" ng-model-options="{trackBy: '$value.id'}" (focus)="onFocus($event)" (blur)="onLostFocus($event)">
            <mat-option *ngFor="let option of options | async" [value]="option[idPropertyName]">
                {{option[valuePropertyName]}}
            </mat-option>
        </mat-select>
</div>